/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {Box, Text} from '@chakra-ui/react'
import {useIntl} from 'react-intl'
import {SALUTATION_OPTIONS, COUNTRY_MESSAGES} from '../../constants'
import {useCountry} from '../../hooks/use-country'
import {stateOptions} from '../forms/state-province-options'

const AddressDisplay = ({address}) => {
    const {formatMessage, locale} = useIntl()
    const country = useCountry()
    let addressDisplay
    const salutation = SALUTATION_OPTIONS.find((option) => option.value === address.salutation)
    const getState = (countryCode, stateCode) => {
        if (!stateOptions[countryCode]) return stateCode
        const state = stateOptions[countryCode].find((elem) => elem.value === stateCode)
        return state ? state.label : stateCode
    }

    if (locale === 'en-US') {
        addressDisplay = (
            <>
                {salutation?.display && <Text>{formatMessage(salutation.label)}</Text>}
                <Text>
                    {address.firstName} {address.lastName}
                </Text>
                <Text>{address.address1}</Text>
                <Text>{address.address2}</Text>
                <Text>
                    {address.city}, {getState('US', address.stateCode)} {address.postalCode}
                </Text>
                <Text>{formatMessage(COUNTRY_MESSAGES[country])}</Text>
            </>
        )
    } else if (locale === 'ja-JP') {
        addressDisplay = (
            <>
                <Text>
                    {address.lastName} {address.firstName}
                </Text>
                <Text>{formatMessage(COUNTRY_MESSAGES[country])}</Text>
                <Text>
                    {address.postalCode} {getState('JP', address.stateCode)} {address.city}
                </Text>
                <Text>{address.address1}</Text>
                <Text>{address.address2}</Text>
            </>
        )
    } else if (locale === 'ko-KR') {
        addressDisplay = (
            <>
                {salutation?.display && <Text>{formatMessage(salutation.label)}</Text>}
                <Text>
                    {address.firstName} {address.lastName}
                </Text>
                <Text>{address.postalCode}</Text>
                <Text>{address.address1}</Text>
                <Text>{address.address2}</Text>
                <Text>{address.city}</Text>
                <Text>{formatMessage(COUNTRY_MESSAGES[country])}</Text>
            </>
        )
    } else {
        addressDisplay = (
            <>
                {salutation?.display && <Text>{formatMessage(salutation.label)}</Text>}
                <Text>
                    {address.firstName} {address.lastName}
                </Text>
                <Text>{address.address1}</Text>
                <Text>{address.address2}</Text>
                <Text>
                    {address.postalCode} {address.city}
                </Text>
                <Text>{formatMessage(COUNTRY_MESSAGES[country])}</Text>
            </>
        )
    }

    return <Box textStyle="Regular Medium">{addressDisplay}</Box>
}

AddressDisplay.propTypes = {
    address: PropTypes.object
}

export default AddressDisplay
